import styled from '@emotion/styled'

import { DurationButton } from '../../atoms'

export type DurationButtonsProps = {
  items: string[]
  onSelect?: (item: string) => void
  readonly?: boolean
  selectedItem?: string
}

const Wrapper = styled.div`
  display: flex;

  div {
    padding: 0 4px;
  }
`

export function DurationButtons({ items, onSelect, readonly, selectedItem }: DurationButtonsProps) {
  return (
    <Wrapper>
      {items.map(x => (
        <div key={x}>
          <DurationButton
            isSelected={x === selectedItem}
            onClick={() => onSelect && !readonly && onSelect(x)}
          >
            {x}
          </DurationButton>
        </div>
      ))}
    </Wrapper>
  )
}
